<div class="page-not-found">
    <div class="mat-display-4">
        <span>404</span>
    </div>
    <h2>Page Not Found</h2>
    <h3>Error code: 404. We can't seem to find the page you're looking for.</h3>
    <br>
    <button mat-flat-button type="button" color="accent" [routerLink]="['/']">Go to home</button>
</div>